﻿export enum BusinessPartnerTypeEnum {
    Customer = 1,
    Supplier = 2,
    Licensor = 3,
}